import { ApiService } from "common/services/ApiService";
import { PENDING_NOTIFICATION_MAP } from "utils/constants";


export const checkPendingNotification = async (auth = {}, setAuth = () => {}, authUpdated = {}) => {
    const role = auth?.selectedRole?.name;
    const res = await ApiService.pendingNotification({
        category: PENDING_NOTIFICATION_MAP[role || "superadmin"]?.join(","),
        read: false,
        establishment: role === "superadmin" ? null : auth?.selectedEstablishment?.id,
        joined_courses: ["superadmin", "admin"].includes(role) ? false : true,
        role_name: role,
    });

    let pendingNotification = {};

    if (PENDING_NOTIFICATION_MAP[role]) {
        pendingNotification = PENDING_NOTIFICATION_MAP[role]?.reduce((acc, category) => {
            acc[category] = res.data.some((item) => item.category === category);
            return acc;
        }, {});
    }

    setAuth({
        ...auth,
        ...authUpdated,
        pendingNotification,
    });

    localStorage.setItem("pendingNotification", JSON.stringify(pendingNotification));
    return pendingNotification;
};